import { PackageCheck, PieChart } from "lucide-react";
import { ExpandBox } from "@/components/Icons";
import Reveal from "@/components/Reveal";
import { lines, mediaUrl, sz, txt, useContent } from "@/content/ContentContext";
import workspace from "@/assets/workspace.jpg";

const featureIcons = [
  <PackageCheck className="wcu-icon" strokeWidth={1.4} key="package" />,
  <PieChart className="wcu-icon" strokeWidth={1.4} key="pie" />,
  <ExpandBox className="wcu-icon" key="expand" />,
];

const WhyChooseUs = () => {
  const c = useContent();
  const w = c.home.whychoose;
  const bg = w.image ? mediaUrl(w.image) : workspace;

  return (
    <section className="whychoose" id="about" style={{ backgroundImage: `url(${bg})` }}>
      <Reveal className="wcu-content" y={22}>
        <h2 className="section-title" style={sz(w.title1)}>
          {txt(w.title1)}
          <br />
          {txt(w.title2)}{" "}
          <span className="text-green" style={sz(w.accent)}>{txt(w.accent)}</span>.
        </h2>
        <p className="section-para" style={sz(w.paragraph)}>
          {lines(w.paragraph)}
        </p>
        <div className="wcu-features">
          {w.features.map((feature, index) => (
            <Reveal
              className="wcu-feature"
              key={index}
              delay={0.15 + index * 0.1}
              y={16}
            >
              {featureIcons[index]}
              <span className="wcu-title" style={sz(feature.title)}>{txt(feature.title)}</span>
            </Reveal>
          ))}
        </div>
      </Reveal>
    </section>
  );
};

export default WhyChooseUs;
